import OutsideClickHandler from "react-outside-click-handler";
import cn from "classnames";
import TextBody from "../TextBody/TextBody";
import styles from "./SortBy.module.scss";
import { parseSortBy } from "./lib/utils";

const OPTIONS = [
  "by-view-score",
  "most-viewed",
  "price-low-to-high",
  "price-high-to-low",
];

export type SortByProps = {
  sortBy: string;
  // eslint-disable-next-line no-unused-vars
  onClick: (o: string) => void;
  onClose: () => void;
};

const SortBy = ({ sortBy, onClick, onClose }: SortByProps) => {
  return (
    <div className={styles.container}>
      <OutsideClickHandler onOutsideClick={onClose}>
        <div className={styles.arrow} />

        <div className={styles.options}>
          {OPTIONS.map((o, i) => (
            <div
              key={i}
              className={styles.option}
              onClick={() => {
                onClick(o);
                onClose();
              }}
            >
              <div
                className={cn(
                  styles.checkbox,
                  sortBy === o ? styles.selected : styles.notSelected
                )}
              />

              <TextBody size="s">{parseSortBy(o)}</TextBody>
            </div>
          ))}
        </div>
      </OutsideClickHandler>
    </div>
  );
};

export default SortBy;
